import { Skeleton } from '@/components/ui'

export const ListaLeadsRepresadosSkeleton = () => {
  return (
    <div className="bg-foreground divide-y divide-neutral-200 rounded-sm px-6 py-6">
      <Skeleton className="mb-4 h-4 w-32" />
      {[1, 2, 3, 4, 5].map((item) => (
        <div key={item} className="hover:bg-muted/50 w-full px-4 py-4 transition-colors">
          <div className="flex content-start items-center justify-between">
            <div className="flex-1 items-start justify-items-start space-y-1">
              <Skeleton className="h-5 w-48" />
              <Skeleton className="h-4 w-64" />
              <Skeleton className="mt-3 h-4 w-40" />
            </div>
            <Skeleton className="h-7 w-7" />
          </div>
        </div>
      ))}
    </div>
  )
}
